// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-no-data[data-v-f5272e88]{position:relative;padding-top:19px;text-align:center;margin-top:20px}.list-no-data__icon[data-v-f5272e88]{position:relative;margin:0 auto 30px;width:150px;height:180px;background:url(https://i.gsxcdn.com/1720099357_qaa9q2yp.png) no-repeat;background-size:100%;background-repeat:no-repeat}.list-no-data__text[data-v-f5272e88]{color:#717274;font-size:16px;height:22px;line-height:22px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
